import { BOOKING_STATUS_LABELS } from '@/config/constants'

const colorMap = {
  // Booking statuses
  pending:          'bg-status-pending/15    text-status-pending    border-status-pending/30',
  quoted:           'bg-siglat-teal/15       text-siglat-teal       border-siglat-teal/30',
  confirmed:        'bg-status-confirmed/15  text-status-confirmed  border-status-confirmed/30',
  assigned:         'bg-status-assigned/15   text-status-assigned   border-status-assigned/30',
  en_route:         'bg-siglat-orange/15     text-siglat-orange     border-siglat-orange/30',
  in_progress:      'bg-status-inprogress/15 text-status-inprogress border-status-inprogress/30',
  pending_approval: 'bg-status-pending/15    text-status-pending    border-status-pending/30',
  completed:        'bg-status-completed/15  text-status-completed  border-status-completed/30',
  cancelled:        'bg-status-cancelled/15  text-status-cancelled  border-status-cancelled/30',
  disputed:         'bg-status-disputed/15   text-status-disputed   border-status-disputed/30',
  // Roles
  customer: 'bg-siglat-teal/10   text-siglat-teal   border-siglat-teal/20',
  worker:   'bg-siglat-amber/10  text-siglat-amber  border-siglat-amber/20',
  admin:    'bg-siglat-red/10    text-siglat-red    border-siglat-red/20',
  // Urgency
  urgent:    'bg-siglat-red/15    text-siglat-red    border-siglat-red/25',
  scheduled: 'bg-surface-overlay  text-ink-secondary border-surface-border',
  // Generic
  success: 'bg-status-completed/15 text-status-completed border-status-completed/30',
  warning: 'bg-status-pending/15   text-status-pending   border-status-pending/30',
  danger:  'bg-status-cancelled/15 text-status-cancelled border-status-cancelled/30',
  neutral: 'bg-surface-overlay     text-ink-secondary    border-surface-border',
}

/**
 * Badge — for status chips, role indicators, urgency labels
 *
 * @param {string} variant — matches a key in colorMap or a booking status
 * @param {string} label   — override the display text (defaults to variant)
 * @param {boolean} dot    — show animated dot (useful for live statuses)
 */
export default function Badge({
  variant = 'neutral',
  label,
  dot = false,
  className = '',
}) {
  const colorClass = colorMap[variant] ?? colorMap.neutral
  const displayLabel = label ?? BOOKING_STATUS_LABELS[variant] ?? variant

  return (
    <span className={`
      status-badge border
      ${colorClass}
      ${className}
    `}>
      {dot && (
        <span className={`w-1.5 h-1.5 rounded-full animate-pulse-dot ${colorClass.split(' ')[1]?.replace('text-', 'bg-')}`} />
      )}
      {displayLabel}
    </span>
  )
}
